import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";

const ReactMultiCreatableSelect = ({
  defaultValues = [],
  onChange = () => {},
  customClass = "",
}) => {
  const [options, setOptions] = useState(defaultValues);

  useEffect(() => {
    setOptions(defaultValues);
  }, [defaultValues]);

  const handleCreate = (inputValue) => {
    const values = inputValue
      .split(",")
      .map((val) => val.trim())
      .filter(Boolean);

    const newOptions = values.map((val) => ({
      label: val,
      value: val,
      __isNew__: true,
    }));

    const updatedOptions = [...options, ...newOptions];
    setOptions(updatedOptions);
    onChange(updatedOptions);
  };

  return (
    <CreatableSelect
      isMulti
      name="tags"
      value={options}
      className={customClass}
      classNamePrefix="select"
      onChange={(selected) => {
        setOptions(selected);
        onChange(selected);
      }}
      onCreateOption={handleCreate}
      placeholder="Add project tags"
      noOptionsMessage={() => null}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          padding: "0.35rem 1rem",
          borderColor: state.isFocused ? "#8499d4" : "#eee",
          borderWidth: "1px",
          boxShadow: "none",
        }),
        valueContainer: (baseStyles, state) => ({
          ...baseStyles,
          padding: "0",
        }),
        placeholder: (baseStyles) => ({
          ...baseStyles,
          fontSize: "0.9rem",
        }),
      }}
    />
  );
};

export default ReactMultiCreatableSelect;
